// Define the color mapping for each Y value (series)
export const colorMapping: Record<string, string> = {
    "IKEA meubelmontage": "#5AAF5C",
    "IKEA badkamer installatie": "#457DA0",
    "IKEA apparatuur installatie": "#FFCB4A",
    "IKEA B2B Meubelmontage": "#DA70D6",
    "IKEA B2B Keukeninstallatie": "#FFAA39"
  };

  // stacked-bar-chart.model.ts
export const colorMappingStack: Record<string, string> = {
  "Leenbakker meubelmontage API": "#5AAF5C", // Blue
  "Leenbakker meubelmontage MODULE": "#FFCB4A", // Orange
  // fallback default colors can be added here if you add more series later
};